import React, { useEffect } from 'react'
import { View } from 'react-native'
import { useSelector } from 'react-redux'
import { Text } from '@src/components/base/Text'
import { NutritionistBubble } from '@src/components/NutritionistBubble'
import { topPriorityCoachAssignmentSelector } from '@src/screens/NutritionistHub/models/nutritionistHub.selectors'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Storage } from '@src/utils'
import { useVideoCallProductType } from '@src/hooks/useVideoCallProductType'
import { useWeightLossExperience } from '../context'
import { Graph } from './Graph'
import { BottomSection } from './BottomSection'

export const PlanDetails = () => {
  const { stepConfig, insurancePolicyIsEligible, onboardingExperience } = useWeightLossExperience()
  const styles = useStyleSheet(themedStyles)
  const coachAssignment = useSelector(topPriorityCoachAssignmentSelector)
  const { isHealthCoachingVideoCallProductType: isHealthCoaching } = useVideoCallProductType()

  useEffect(() => {
    Storage.set(Storage.WEIGHT_LOSS_EXPERIENCE_VISIT_PLAN_DETAILS_KEY, true)
  }, [])

  return (
    <>
      <View style={{ alignItems: 'center' }}>
        {stepConfig?.bubbleText && (
          <NutritionistBubble
            label={stepConfig.bubbleText}
            photoSrc={coachAssignment?.coach?.coachProfile?.photo}
          />
        )}

        <Text
          type="regular"
          style={[styles.description, { marginTop: insurancePolicyIsEligible ? 100 : 0 }]}
        >
          {stepConfig?.description}
        </Text>

        <Graph
          insurancePolicyIsEligible={insurancePolicyIsEligible}
          hidesGoalDate={isHealthCoaching}
          onboardingExperience={onboardingExperience}
        />
      </View>

      <BottomSection />
    </>
  )
}

const themedStyles = StyleService.create({
  description: {
    fontSize: 15,
    textAlign: 'center',
    marginTop: 100,
  },
})
